import { useState } from 'react';
import { CalendarDays, Bell, MessagesSquare, Smartphone, PartyPopper, ChevronRight, ChevronLeft, X } from 'lucide-react';
import { trainerKalenderAPI } from '@/lib/api';

/* Einführung im Trainer-Link (29.10.2026, Betreiber: „Onboarding für alle Mitarbeiter“). Erscheint beim ersten Öffnen,
   bis der Trainer sie abschließt (POST /{token}/onboarding → trainer_links.onboarding_am, im CRM bei den Trainer-Links
   sichtbar). Über „?“ oben jederzeit wieder. */

const P1_ROT = '#E60000';

function schritte(name) {
  const vorname = (name || '').split(' ')[0];
  return [
    { icon: Smartphone, titel: `Hi ${vorname}! Das ist dein Trainer-Link`,
      text: 'Hier siehst du alle deine Termine und die Nachrichten von Philip. Ohne Login — der Link ist dein Schlüssel, gib ihn nicht weiter.',
      tipp: 'Leg ihn gleich auf den Home-Bildschirm: iPhone › Safari › Teilen-Symbol › „Zum Home-Bildschirm“. Android › Chrome › ⋮ › „Zum Startbildschirm hinzufügen“.' },
    { icon: CalendarDays, titel: 'Dein Kalender',
      text: 'Rot sind deine Personal Trainings, blau Termine aus Philips Kalender, grau gestrichelt die anderer Trainer. Graue Flächen liegen außerhalb deiner Arbeitszeit oder an Schultagen — dort geht kein PT.',
      tipp: 'Freie Zeit antippen = selbst ein PT eintragen. Oder oben „Termin sprechen“: „Dienstag um zehn eine Stunde mit Max“.' },
    { icon: Bell, titel: 'Feste Termine und Anfragen',
      text: 'Termine von Philip (Chat oder sein Kalender) stehen sofort fest in deinem Kalender. Trägt jemand anderes aus dem Studio dir ein PT ein, erscheint oben eine gelbe Box mit „Annehmen“ oder „Ablehnen“.',
      tipp: 'Gelbe Anfragen bitte immer am selben Tag beantworten.' },
    { icon: MessagesSquare, titel: 'Chat mit Philip',
      text: 'Montags schickt Philip dir im Reiter „Chat“ deine Termine der Woche. Sie stehen dann automatisch in deinem Kalender. Schreibt dir Cagla dort einen Termin, kommt er als gelbe Anfrage. Die Zahl am Reiter zeigt neue Nachrichten.',
      tipp: 'Sobald du den Chat öffnest, sieht Philip „gelesen“. Fragen oder „Passt!“ schreibst du direkt dort zurück.' },
    { icon: PartyPopper, titel: 'Fertig — so einfach ist das',
      text: 'Kurz zusammengefasst: 1. Link auf den Home-Bildschirm. 2. Montags Chat lesen. 3. Gelbe Anfragen beantworten. 4. Vor jedem Training kurz in den Kalender schauen.',
      tipp: 'Die Einführung findest du jederzeit wieder über das „?“ oben rechts.' },
  ];
}

export default function TrainerEinfuehrung({ token, name, onFertig, onSchliessen }) {
  const s = schritte(name);
  const [i, setI] = useState(0);
  const [arbeitet, setArbeitet] = useState(false);
  const S = s[i];
  const Icon = S.icon;
  const fertig = async () => {
    setArbeitet(true);
    try { await trainerKalenderAPI.onboarding(token); } catch { /* Abschluss ist Nebensache: der Link läuft trotzdem */ }
    setArbeitet(false);
    onFertig?.();
  };
  return (
    <div className="fixed inset-0 z-40 bg-black/50 flex items-end sm:items-center justify-center p-3" data-testid="trainer-einfuehrung">
      <div className="w-full max-w-md rounded-2xl bg-background p-5 shadow-xl space-y-4">
        <div className="flex items-center justify-between">
          <div className="flex gap-1.5">{s.map((_, k) => <span key={k} className={`h-1.5 w-6 rounded-full ${k <= i ? '' : 'bg-muted-foreground/25'}`} style={k <= i ? { background: P1_ROT } : undefined} />)}</div>
          <button type="button" onClick={onSchliessen} className="text-muted-foreground" aria-label="Später"><X className="w-4 h-4" /></button>
        </div>
        <div className="w-12 h-12 rounded-xl flex items-center justify-center text-white" style={{ background: P1_ROT }}><Icon className="w-6 h-6" /></div>
        <div className="space-y-2">
          <h2 className="text-lg font-bold">{S.titel}</h2>
          <p className="text-sm">{S.text}</p>
          <p className="text-sm rounded-lg bg-muted p-3">{S.tipp}</p>
        </div>
        <div className="flex gap-2">
          {i > 0 && <button type="button" onClick={() => setI(i - 1)} className="h-11 px-4 rounded-xl border border-border text-sm font-semibold flex items-center gap-1"><ChevronLeft className="w-4 h-4" /> Zurück</button>}
          {i < s.length - 1
            ? <button type="button" onClick={() => setI(i + 1)} className="h-11 flex-1 rounded-xl text-white text-sm font-semibold flex items-center justify-center gap-1" style={{ background: P1_ROT }}>Weiter <ChevronRight className="w-4 h-4" /></button>
            : <button type="button" onClick={fertig} disabled={arbeitet} className="h-11 flex-1 rounded-xl text-white text-sm font-semibold" style={{ background: P1_ROT }} data-testid="einfuehrung-fertig">Los geht&apos;s</button>}
        </div>
      </div>
    </div>
  );
}
